export const ExportRoute = {
  EXPORT: {
    path: 'export',
    name: 'export-viewer'
  }
};
